import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'

export interface GeneralSettingsTabProps {
  name: string
  setName: (name: string) => void
  url: string
  setUrl: (url: string) => void
  websiteDomainName?: string
}

export const GeneralSettingsTab = ({
  name,
  setName,
  url,
  setUrl,
  websiteDomainName = 'domain.placeholder.com',
}: GeneralSettingsTabProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-2">
      <TextInputControl
        id="name"
        wrapperProps={{
          className: 'flex mt-0',
          labelText: t('pages_management.create_page_name_label'),
          required: true,
        }}
        value={name}
        update={setName}
      />
      <div className="mt-4 flex flex-col gap-2">
        <div className="flex items-baseline">
          <TextInputControl
            wrapperProps={{
              className: 'mt-0 w-full',
              labelText: t('pages_management.create_page_url_label'),
              required: true,
            }}
            appendix={
              <span className="whitespace-nowrap">{`https://${websiteDomainName}/`}</span>
            }
            id="url"
            value={url}
            update={setUrl}
          />
        </div>
      </div>
    </div>
  )
}
